module.exports = __webpack_public_path__ + "media/images/mares-08f0b6b0fc675fd19053ee474ad3df15.jpg";